import {connect} from "react-redux";
import ShopsPage from "./ShopsPage";
import * as InventoryApiActions from "../../actions/InventoryApiActions";
import * as ViewActions from "../../actions/ViewActions";
import {graphql} from "react-apollo";
import {LIST_SHOPS} from "../../queries/sales";

function mapStateToProps(state) {
  return {
  }
}

const withQueries = graphql(LIST_SHOPS);

export default connect(mapStateToProps, {...InventoryApiActions, ...ViewActions})(withQueries(ShopsPage));